import { map } from 'rxjs/operators';
var Language;
(function (Language) {
    Language["EN"] = "en";
    Language["DE"] = "de";
})(Language || (Language = {}));
/**
 * Service responsible for duplicating the storage item
 * Important for CH where we need to support storage translation
 */
export class ShadowStorage {
    constructor(shadowBasketData, basketDataTransformer, basketStorage, contentService) {
        this.shadowBasketData = shadowBasketData;
        this.basketDataTransformer = basketDataTransformer;
        this.basketStorage = basketStorage;
        this.contentService = contentService;
        this.investorTypes = typeof this.contentService.get('investor-types-map', '{}') === 'string'
            ? JSON.parse(this.contentService.get('investor-types-map', '{}'))
            : this.contentService.get('investor-types-map', '{}');
        this.investorTypesReverse = this.reverseInvTypes();
        this.basketKey = this.basketStorage.getBasketKey;
        this.language = this.basketKey.includes(`-${Language.DE}`)
            ? Language.DE
            : Language.EN;
        this.activeInvestorTypes = this.language === Language.EN ? this.investorTypesReverse : this.investorTypes;
        this.productsText = this.contentService.get('PRODUCTS', 'products');
        this.productsTranslatedText = this.contentService.get('PRODUCTS_TRANSLATED', 'produkte');
        this.replaceCompareUrl();
        this.basketStorage.setBasketKey = this.replaceBasketKey();
    }
    static getLanguageDelimiter(language, delimiter) {
        if (delimiter === '/') {
            return `/${language}/`;
        }
        return `-${language}`;
    }
    static replaceInvestorType(str, InvestorTypes) {
        let localStr = str;
        Object.entries(InvestorTypes).forEach((investorType) => {
            localStr = localStr.replace(investorType[0], investorType[1]);
        });
        return localStr;
    }
    storeBasketGateway(basketIds = []) {
        if (basketIds.length === 0) {
            this.basketStorage.storeBasket({ funds: [] });
        }
        else {
            this.shadowBasketData
                .getProductData(basketIds)
                .pipe(map((resp) => this.basketDataTransformer.mapApiResponseToBasketItems(resp.data, basketIds)))
                .subscribe((funds) => this.basketStorage.storeBasket({ funds: this.replaceBasketUrl(funds) }));
        }
    }
    replaceBasketUrl(funds) {
        return funds.map((fund) => {
            const fundItem = fund;
            Object.entries(this.activeInvestorTypes).forEach((investorType) => {
                let { url } = fundItem;
                url = this.replaceLanguage(url, '/', true).replace(investorType[0], investorType[1]);
                fundItem.url = url;
            });
            return fundItem;
        });
    }
    replaceCompareUrl() {
        const compareApiUrl = this.replaceLanguage(this.shadowBasketData.getCompareApiUrl);
        this.shadowBasketData.setCompareApiUrl = ShadowStorage.replaceInvestorType(compareApiUrl, this.activeInvestorTypes);
    }
    replaceBasketKey() {
        return ShadowStorage.replaceInvestorType(this.replaceLanguage(this.basketKey, '-'), this.activeInvestorTypes);
    }
    replaceLanguage(str, delimiter = '/', productsCondition = false) {
        let localStr = str;
        if (this.language === Language.DE) {
            if (productsCondition) {
                localStr = localStr.replace(`/${this.productsText}/`, `/${this.productsTranslatedText}/`);
            }
            return localStr.replace(ShadowStorage.getLanguageDelimiter(Language.DE, delimiter), ShadowStorage.getLanguageDelimiter(Language.EN, delimiter));
        }
        if (productsCondition) {
            localStr = localStr.replace(`/${this.productsText}/`, `/${this.productsTranslatedText}/`);
        }
        return localStr.replace(ShadowStorage.getLanguageDelimiter(Language.EN, delimiter), ShadowStorage.getLanguageDelimiter(Language.DE, delimiter));
    }
    reverseInvTypes() {
        const reverse = {};
        Object.entries(this.investorTypes).forEach((investorType) => {
            const [translation0, translation1] = investorType;
            reverse[translation1] = translation0;
        });
        return reverse;
    }
}
